import { useHasScrolled } from "@atlassiansox/bxp-content-framework";

import { useIsLoggedIn, useIdentityUrl } from "../../components";
import { UiHeaderNavModel } from "../../models";

import { BigNav } from "./big";
import { SmallNav } from "./small";
import Skip from "./UiHeaderNav.styles";

export type UiHeaderNavProps = {
    readonly model: UiHeaderNavModel;
};

const UiHeaderNav = ({ model: model }: UiHeaderNavProps) => {
    const identitySignupUrl = useIdentityUrl();
    const identityLoginUrl = useIdentityUrl({ isLogin: true });

    const hasScrolled = useHasScrolled(40);
    const isLoggedIn = useIsLoggedIn();

    return (
        <>
            <Skip>
                <a
                    id="skip-to-content"
                    href="#skip-target"
                    className="visually-hidden"
                >
                    {model.content.skipToMainContent ?? "Skip to main content"}
                </a>
            </Skip>
            <BigNav
                hasScrolled={hasScrolled}
                isLoggedIn={isLoggedIn}
                model={model}
                signUpUrl={identitySignupUrl}
                loginUrl={identityLoginUrl}
            />
            <SmallNav
                hasScrolled={hasScrolled}
                isLoggedIn={isLoggedIn}
                model={model}
                signUpUrl={identitySignupUrl}
                loginUrl={identityLoginUrl}
            />
        </>
    );
};

export default UiHeaderNav;
